import { PaymentPortal } from "@app/checkout/components/PaymentPortal";
import { UnlockCodePortal } from "@app/shared/components/UnlockCodePortal";
import { SharePortal } from "../SharePortal/SharePortal";

const portals = [SharePortal, PaymentPortal, UnlockCodePortal];

export function PortalsWrapper() {
  return (
    <>
      {portals.map((Portal, index) => (
        <Portal key={index} />
      ))}
    </>
  );
}
